const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 150,
    viewBox: "0 0 260 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.38298,0,0,1.36364,-1955.53,-1588.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1602,1192.5C1602,1177.32 1589.85,1165 1574.88,1165L1441.12,1165C1426.15,1165 1414,1177.32 1414,1192.5L1414,1247.5C1414,1262.68 1426.15,1275 1441.12,1275L1574.88,1275C1589.85,1275 1602,1262.68 1602,1247.5L1602,1192.5Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2766,0,0,1.18182,-1795.11,-1366.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1602,1192.5C1602,1177.32 1590.59,1165 1576.54,1165L1439.46,1165C1425.41,1165 1414,1177.32 1414,1192.5L1414,1247.5C1414,1262.68 1425.41,1275 1439.46,1275L1576.54,1275C1590.59,1275 1602,1262.68 1602,1247.5L1602,1192.5Z",
    style: {
      fill: "url(#_Linear2)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10,-25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,96C184,71.699 164.301,52 140,52C115.716,52 96,71.716 96,96C96,120.301 115.699,140 140,140L140,123.383C124.877,123.383 112.617,111.123 112.617,96C112.617,80.887 124.887,68.617 140,68.617C155.123,68.617 167.383,80.877 167.383,96L184,96Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.73368e-17,0.609756,-0.609756,3.73368e-17,191.634,28.561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127,46L168,106L86,106L127,46Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(141.723,80.6667,-79.5385,143.733,1439.31,1178.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,107,226)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,61,128)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-147.267,-77,71.2833,-159.077,1580.85,1256.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,164,224)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,155,210)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.f49f61f8268c984d0349c6a348a3b6db.svg";
export { ForwardRef as ReactComponent };